(function(){
  function init(root){
    if(!root || root.__ds) return; root.__ds = true;
    var cards = [].slice.call(root.querySelectorAll('[data-ds-card]'));
    var low = parseInt(root.dataset.low || '2', 10);
    var T = {
      pick: root.dataset.tPick || 'Pick your size',
      instock: root.dataset.tInstock || 'In stock',
      low: root.dataset.tLow || 'Only [count] left',
      add: DS.t('add_to_cart', 'Add to cart'),
      select: DS.t('select_size', 'Select size'),
      choose: DS.t('choose_size', 'Choose your size first')
    };
    var activeSize = null, activeBrand = null;
    var limit = parseInt(root.dataset.limit || '0', 10) || 0;   /* products shown before "Ver más" */
    var step = parseInt(root.dataset.step || '10', 10) || 10;
    var shownLimit = limit;
    var moreBtn = root.querySelector('[data-ds-more]');

    function setStock(card, btn){
      var el = card.querySelector('[data-ds-stock]'); if(!el) return;
      var q = btn ? parseInt(btn.dataset.qty,10) : 99;
      el.classList.remove('is-low');
      if (btn && btn.dataset.available !== 'true') { el.innerHTML = '<span class="ds-dot ds-dot--out"></span><span>' + DS.t('sold_out_in', 'Sold out in') + ' ' + btn.dataset.size + '</span>'; return; }
      if (btn && q > 0 && q <= low) { el.classList.add('is-low'); el.innerHTML = '<span class="ds-dot ds-dot--low ds-dot--pulse"></span><span>' + T.low.replace('[count]', q) + '</span>'; return; }
      el.innerHTML = '<span class="ds-dot"></span><span>' + (btn ? T.instock : T.pick) + '</span>';
    }

    function selectSize(card, btn){
      card.querySelectorAll('.ds-size').forEach(function(b){ b.setAttribute('aria-checked', b===btn ? 'true':'false'); });
      var add = card.querySelector('[data-ds-add]'), buy = card.querySelector('[data-ds-buy]');
      var ok = btn && btn.dataset.available === 'true';
      card.dataset.variant = ok ? btn.dataset.variant : '';
      card.dataset.size = btn ? btn.dataset.size : '';
      if (add) {
        add.disabled = btn && !ok;
        var label = !btn ? T.select : (ok ? T.add + ' · ' + DS.money(+btn.dataset.price) : DS.t('sold_out', 'Sold out'));
        add.textContent = label; add.setAttribute('data-label', label);
      }
      if (buy) buy.hidden = !ok;
      setStock(card, btn);
    }

    cards.forEach(function(card){
      card.querySelectorAll('.ds-size').forEach(function(btn){
        btn.addEventListener('click', function(){ if (btn.dataset.available === 'true') selectSize(card, btn); });
      });
      var add = card.querySelector('[data-ds-add]');
      if (add) add.addEventListener('click', function(){
        var vid = card.dataset.defaultVariant || card.dataset.variant;
        if (!vid) {
          var row = card.querySelector('[data-ds-card-sizes]');
          if (row) { row.classList.remove('is-shake'); void row.offsetWidth; row.classList.add('is-shake'); }
          var st = card.querySelector('[data-ds-stock]'); if (st) st.innerHTML = '<span class="ds-dot ds-dot--low"></span><span>' + T.choose + '</span>';
          return;
        }
        DS.addToCart(vid, 1, add, { title: card.dataset.title, variant: card.dataset.size ? DS.t('size', 'Size') + ' ' + card.dataset.size : '', image: card.dataset.image });
      });
      var buy = card.querySelector('[data-ds-buy]');
      if (buy) buy.addEventListener('click', function(){ DS.buyNow(card.dataset.defaultVariant || card.dataset.variant); });
      if (card.dataset.defaultVariant) { var b = card.querySelector('[data-ds-buy]'); if (b) b.hidden = false; }
    });

    var sizeWrap = root.querySelector('[data-ds-sizes]');
    var brandWrap = root.querySelector('[data-ds-brands]');
    var countEl = root.querySelector('[data-ds-count]');
    var clearBtns = root.querySelectorAll('[data-ds-clear]');
    var empty = root.querySelector('[data-ds-empty]');

    var ONE = /^(talla\s*[uú]nica|[uú]nica|one\s*size|os)$/i;
    function noSizes(card){ return !card.querySelector('.ds-size'); }
    function cardOk(card){ return !card.querySelector('[data-ds-add][disabled]'); }
    function cardHasSize(card, size){
      if (ONE.test(size) && noSizes(card)) return cardOk(card) ? card : null;
      var b = card.querySelector('.ds-size[data-size="' + CSS.escape(size) + '"]');
      if (b && b.dataset.available === 'true') return b;
      /* half sizes: 37.5 also shows under 37 and 38 */
      var n = parseFloat(size);
      if (!isNaN(n) && n % 1 === 0) {
        var hs = card.querySelectorAll('.ds-size[data-available="true"]');
        for (var i = 0; i < hs.length; i++) {
          var v = parseFloat(String(hs[i].dataset.size).replace(',', '.'));
          if (!isNaN(v) && v % 1 !== 0 && Math.abs(v - n) === 0.5) return hs[i];
        }
      }
      return null;
    }
    function word(n){ return n + ' ' + (n === 1 ? DS.t('style', 'style') : DS.t('styles', 'styles')); }

    function apply(){
      var shown = 0, filtering = !!(activeSize || activeBrand);
      cards.forEach(function(card){
        var okBrand = !activeBrand || card.dataset.vendor === activeBrand;
        var btn = activeSize ? cardHasSize(card, activeSize) : null;
        var okSize = !activeSize || !!btn;
        var show = okBrand && okSize;
        /* no filter: only the first [shownLimit] products; with a size/brand filter: every match */
        if (show && !filtering && limit && shown >= shownLimit) show = false;
        card.classList.toggle('is-hidden', !show);
        if (show) {
          shown++;
          card.classList.add('is-filtering');
          requestAnimationFrame(function(){ requestAnimationFrame(function(){ card.classList.remove('is-filtering'); }); });
          if (activeSize && btn && btn !== card) selectSize(card, btn);
          else if (!activeSize && card.dataset.size && card.dataset.autoselected === '1') { selectSize(card, null); }
          card.dataset.autoselected = activeSize ? '1' : '';
        }
      });
      if (countEl) countEl.textContent = (activeSize || activeBrand) ? word(shown) + (activeSize ? (ONE.test(activeSize) ? ' · ' + activeSize : ' ' + DS.t('in_size', 'in size') + ' ' + activeSize) : '') : word(cards.length);
      clearBtns.forEach(function(b){ if (!b.classList.contains('ds-shop__clear-inline')) b.hidden = !(activeSize || activeBrand); });
      if (empty) empty.hidden = shown > 0 || !cards.length;
      if (moreBtn) {
        var left = cards.length - shown;
        moreBtn.hidden = filtering || !limit || left <= 0;
        moreBtn.textContent = (moreBtn.dataset.label || 'Ver más') + ' (' + left + ')';
      }
      if (sizeWrap) sizeWrap.querySelectorAll('.ds-chip').forEach(function(c){ c.setAttribute('aria-pressed', c.dataset.v === activeSize ? 'true' : 'false'); });
      if (brandWrap) brandWrap.querySelectorAll('.ds-chip').forEach(function(c){ c.setAttribute('aria-pressed', c.dataset.v === activeBrand ? 'true' : 'false'); });
    }

    function chip(label, val, enabled, onClick){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ds-chip'; b.textContent = label; b.dataset.v = val;
      b.setAttribute('aria-pressed','false');
      if (!enabled) { b.disabled = true; b.title = DS.t('out_of_stock', 'Out of stock'); }
      b.addEventListener('click', onClick);
      return b;
    }

    if (sizeWrap) {
      var sizes = {}, avail = {};
      cards.forEach(function(card){
        card.querySelectorAll('.ds-size').forEach(function(b){
          sizes[b.dataset.size] = true;
          if (b.dataset.available === 'true') {
            avail[b.dataset.size] = true;
            var v = parseFloat(String(b.dataset.size).replace(',', '.'));
            if (!isNaN(v) && v % 1 !== 0) { avail[String(Math.floor(v))] = true; avail[String(Math.ceil(v))] = true; }
          }
        });
      });
      var oneLabel = null;
      (root.dataset.sizes || '').split(',').forEach(function(x){ if (ONE.test(x.trim())) oneLabel = x.trim(); });
      if (oneLabel) cards.forEach(function(card){ if (noSizes(card)) { sizes[oneLabel] = true; if (cardOk(card)) avail[oneLabel] = true; } });
      var fixed = (root.dataset.sizes || '').split(',').map(function(x){ return x.trim(); }).filter(Boolean);
      var list = fixed.length ? fixed : Object.keys(sizes).sort(function(a,b){ return DS.sizeKey(a) - DS.sizeKey(b); });
      list.forEach(function(s){
        sizeWrap.appendChild(chip(s, s, !!avail[s], function(){ activeSize = activeSize === s ? null : s; apply(); }));
      });
      if (!list.length) { var bar = root.querySelector('[data-ds-bar]'); if (bar) bar.hidden = true; }
    }
    if (brandWrap) {
      var brands = {};
      cards.forEach(function(c){ if (c.dataset.vendor) brands[c.dataset.vendor] = true; });
      var blist = Object.keys(brands).sort();
      if (blist.length < 2) { brandWrap.parentElement.hidden = true; }
      blist.forEach(function(v){ brandWrap.appendChild(chip(v, v, true, function(){ activeBrand = activeBrand === v ? null : v; apply(); })); });
    }
    clearBtns.forEach(function(b){ b.addEventListener('click', function(){ activeSize = null; activeBrand = null; apply(); }); });
    if (moreBtn) moreBtn.addEventListener('click', function(){ shownLimit += step; apply(); });

    /* Always start with no size selected. Clean up any old saved size and ?size= in the address bar. */
    try {
      localStorage.removeItem('ds_size');
      var u = new URL(location.href);
      if (u.searchParams.has('size')) { u.searchParams.delete('size'); history.replaceState(null, '', u); }
    } catch(e){}
    apply();
  }
  function all(scope){ (scope || document).querySelectorAll('[data-ds-shop]').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', function(){ all(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();